import type { IconSvgObject } from './types';

const FolderKeyIcon: IconSvgObject = [
  ["path", { d: "M17.5 18L22 13.5M21 15L22 16M18 19.5C18 20.6046 17.1046 21.5 16 21.5C14.8954 21.5 14 20.6046 14 19.5C14 18.3954 14.8954 17.5 16 17.5C17.1046 17.5 18 18.3954 18 19.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 6.49446H12.0179M12.0179 6.49446H20C21.1046 6.49446 22 7.38989 22 8.49446V9.5M12.0179 6.49446L9.60016 3.29437C9.22218 2.79407 8.63144 2.5 8.0044 2.5H4C2.89543 2.5 2 3.39543 2 4.5V18.5C2 19.6046 2.89543 20.5 4 20.5H10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FolderKeyIcon;
